import { Injectable } from '@angular/core';
import { HashTable } from '../interfaces/general.interfaces';
import { Observable, Subject } from 'rxjs';

interface IPersistenceNode {
  onValueChanged: Subject<string>;
  value: string;
}

@Injectable()
export class GlobalUiPersistenceService {


  private _allowedKeys: HashTable<string> = {}; // for unique names/keys
  private _persistenceStorage: HashTable<IPersistenceNode> = {}; // for values storage

  set allowedKeys(value: HashTable<string>) {
    this._allowedKeys = value;
    this.initPersistenceStorage();
  }



  set(key: string, value: string) {

    if (this._allowedKeys[key]) {

      localStorage.setItem(key, value);

      this._persistenceStorage[key].value = value;
      this._persistenceStorage[key].onValueChanged.next(value);

    } else {
      throw new Error('The key ' + key + ' is not supported');
    }

  }

  get(key: string): string {
    if (this._persistenceStorage[key] && this._persistenceStorage[key].value !== undefined) {
      return this._persistenceStorage[key].value;
    }

    return localStorage.getItem(key);
  }

  getKeyObservable(key: string): Observable<string> {
    return this._persistenceStorage[key].onValueChanged.asObservable();
  }

  private initPersistenceStorage() {
    Object.keys(this._allowedKeys).forEach((allowedKey: string) => {
      this._persistenceStorage[allowedKey] = { value: undefined, onValueChanged: new Subject<string>() };
    });
  }
}
